import React, { useState } from "react";
import useLocalStorage from "../Utility/useLocalStorage.js";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";


function ListaConnettoriErrore({ listItems }) {

    const [bkFascicolo, setBkFascicolo, removeBkFasicolo] = useLocalStorage("BkFascicolo");

    const [filterFascicolo, setFilterFascicolo, removeFilterFascicolo] =
        useLocalStorage("FilterFascicolo");
    const [responseFascicolo, setResponseFascicolo, removeResponseFascicolo] =
        useLocalStorage("responseFascicolo")
    const [listEelementsInError, setListEelementsInError, removeListErrorInError] = useLocalStorage("ListError");



    const resetPage = () => {

        removeResponseFascicolo()
        removeBkFasicolo()
        removeFilterFascicolo()
        removeListErrorInError()
        window.location.reload()
    }



    return (
        <>

            <div className="card card-teaser rounded shadow">            
                <div className="card-body row">                
                    <div className="col-11">
                        <div id="collapseError" className="collapse-div  px-2 collapsed" role="tablist" >
                            <div className="collapse-header" id="headingErrorList">
                                <button data-toggle="collapse" data-target="#collapse1" aria-expanded="true" aria-controls="collapse1" className="text-warning collapseCustom">
                                    Non è stato possibile recuperare  {listItems.length.length > 1 ? <>{listItems.length} tipi di cartella</> : <>un tipo di cartella</>}
                                </button>
                            </div>
                            <div id="collapse1" className="collapse show" role="tabpanel" aria-labelledby="headingErrorList">
                                <div className="collapse-body row">
                                    <div className="col-9 mb-2">
                                        <ul>
                                            {listItems.map((obbj, index) => (
                                                <li key={index} className="text-warning">{obbj.tipoEntrata} ({obbj.userMessage})</li>
                                            ))}
                                        </ul>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-1 pt-2 text-center" data-toggle="tooltip" data-placement="top" title="Ricarica il Fascicolo"> <svg className="icon   icon-warning"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            resetPage();
                        }}

                    >
                        <use
                            href={`${iconSprite}#it-exchange-circle`}
                        />
                    </svg></div>


                </div>




            </div>
        </>
    );
}

export default ListaConnettoriErrore;
